import {Dimensions, Platform} from 'react-native';
import {RFValue} from 'react-native-responsive-fontsize';

const {width: SCREEN_WIDTH, height: SCREEN_HEIGHT} = Dimensions.get('screen');
const {width: WINDOW_WIDTH, height: WINDOW_HEIGHT} = Dimensions.get('window');
const PHONE_BREAKPOINT = 768;
const guidelineBaseWidth = 412;
const guidelineBaseHeight = 800;
const isPhone = WINDOW_WIDTH <= PHONE_BREAKPOINT;
const wrapFail = WINDOW_WIDTH <= 1424;
const isPortrait = WINDOW_HEIGHT / WINDOW_WIDTH > 1.3;
const hs = (size: number): number =>
  (Math.min(WINDOW_WIDTH, 600) / guidelineBaseWidth) * size;

const vs = (size: number): number =>
  (Math.min(WINDOW_HEIGHT, 1000) / guidelineBaseHeight) * size;

const ms = (size: number, factor: number = 0.5): number =>
  size + (hs(size) - size) * factor;

const Spacing = {
  xxxSmall: ms(4),
  xxSmall: ms(8),
  xSmall: ms(12),
  small: ms(16),
  regular: ms(20),
  large: ms(24),
  xLarge: ms(28),
  xxLarge: ms(32),
  xxxLarge: ms(36),
  extraLarge: ms(48),
};

const Sizes = {
  '2': hs(2),
  '4': hs(4),
  '8': hs(8),
  '12': hs(12),
  '13': hs(13),
  '16': hs(16),
  '20': hs(20),
  '24': hs(24),
  '28': hs(28),
  '32': hs(32),
  '36': hs(36),
  '40': hs(40),
  '44': hs(44),
  '48': hs(48),
};
// OLD (unbounded on large screens)
// const scaleFactor = isPhone ? 800 : WINDOW_WIDTH < 2100 ? 1500 : 2900;

// NEW (safe for mobile + web)
const BASE_WIDTH = 375; // iPhone X baseline
const MIN_SCALE = 0.85;
const MAX_SCALE = 1.25;

// Normalize + clamp scale
const scale = Math.min(
  Math.max(WINDOW_WIDTH / BASE_WIDTH, MIN_SCALE),
  MAX_SCALE
);

// Optional: slightly tighter cap for web (recommended)
const finalScale =
  Platform.OS === 'web' && WINDOW_WIDTH > 768
    ? Math.min(scale, 1.15)
    : scale;

// Slightly downscale on small screens (<768) to keep fonts comfortable
const fontScale =
  WINDOW_WIDTH < PHONE_BREAKPOINT ? finalScale * 0.94 : finalScale;

// Safe RFValue replacement
const RFValueSafe = (size: number) =>
  Math.round(size * fontScale);

// Font sizes
const FontSizes = {
  '8': RFValueSafe(8),
  '9': RFValueSafe(9),
  '10': RFValueSafe(10),
  '11': RFValueSafe(11),
  '12': RFValueSafe(12),
  '13': RFValueSafe(13),
  '14': RFValueSafe(14),
  '15': RFValueSafe(15),
  '16': RFValueSafe(16),
  '18': RFValueSafe(18),
  '20': RFValueSafe(20),
  '21': RFValueSafe(21),
  '24': RFValueSafe(24),
  '28': RFValueSafe(28),
  '32': RFValueSafe(32),
  '36': RFValueSafe(36),
  '40': RFValueSafe(40),
  '48': RFValueSafe(48),
  '51': RFValueSafe(51),
  '81': RFValueSafe(81),
};


const BorderRadius = {
  small: 4,
  medium: 8,
  large: 12,
};

const BottomBarHeight = vs(56);

export {
  SCREEN_WIDTH,
  SCREEN_HEIGHT,
  WINDOW_WIDTH,
  WINDOW_HEIGHT,
  Spacing,
  Sizes,
  FontSizes,
  BorderRadius,
  BottomBarHeight,
  PHONE_BREAKPOINT,
  isPhone,
  hs,
  vs,
  ms,
  wrapFail,
  isPortrait,
};
